export var errorLog=function errorLog(nameSpace,msg){throw new Error("".concat(nameSpace," -> ").concat(msg));};